import { AxiosResponse } from "axios";
import { axiosClient } from "../../axiosClient";
import { axiosSafeRequest } from "../../axiosSafeRequest";

/**
 * Get authorization status for the current user.
 *
 * @returns An HTTP response.
 */
export const apiAccountStatusGet = async (): Promise<AxiosResponse | undefined> => {
  return axiosSafeRequest(() => axiosClient.get('/account/status'));
}
